module.exports = __webpack_public_path__ + "img/SKMJ_cap7.e557c508.jpg";